export const LsIconTypes = [
  'add',
  'ascending',
  'calendar',
  'cancel',
  'chat',
  'check',
  'checkfull',
  'checkmark',
  'chevron',
  'circlepulse',
  'clock',
  'clockf',
  'close',
  'copy',
  'creditcard',
  'dashes',
  'denied',
  'descending',
  'drag',
  'edit',
  'email',
  'exclamation',
  'facebook',
  'fertilizer',
  'gift',
  'google',
  'hamburger',
  'hourglass',
  'mobile',
  'more',
  'nextdoor',
  'phone',
  'photo',
  'pin',
  'quote',
  'skip',
  'star',
  'staroutline',
  'thumbsup',
  'thunder',
  'twitter',
  'user',
  'resize',
];

export const LsIconSizes = {
  xs: 10,
  sm: 15,
  md: 20,
  lg: 25,
  xlg: 30,
  xxlg: 40,
};
